import React from 'react'

const Bar = ({ width = '100%' }) => (
  <span className="hc-skel__bar" style={{ width }} aria-hidden="true" />
)

export const SidebarSkeleton = () => (
  <nav className="hc-sidebar hc-skel" aria-hidden="true">
    <ul className="hc-sidebar__list">
      {[0, 1, 2, 3, 4].map(i => (
        <li key={i} className="hc-sidebar__chapter">
          <div className="hc-skel__chapter">
            <Bar width="60%" />
          </div>
          <ul className="hc-sidebar__articles">
            {[0, 1, 2].map(j => (
              <li key={j}><Bar width={`${50 + ((i + j) * 7) % 30}%`} /></li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  </nav>
)

export const ArticleSkeleton = () => (
  <section className="hc-article hc-skel" aria-hidden="true">
    <header className="hc-article__header">
      <Bar width="20%" />
      <Bar width="60%" />
      <Bar width="85%" />
    </header>
    <div className="hc-article__body">
      {[95, 100, 88, 100, 92, 70, 100, 96, 60].map((w, i) => (
        <Bar key={i} width={`${w}%`} />
      ))}
    </div>
  </section>
)
